import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { BaseViewComponent } from '@sb/library/base';
import { ClipboardManager } from '@sb/library/managers';

@Component({
    selector: 'lib-copy-to-clipboard',
    templateUrl: './clipboard.component.html',
    styleUrls: ['./clipboard.component.scss']
})
export class ClipboardComponent extends BaseViewComponent {
    @ViewChild('content') content!: ElementRef;

    @Input() message: string = $localize`:@@CommonCopiedToClipboard:Text copied to clipboard`;
    @Input() textToCopy: string | SafeHtml | null = null;
    @Input() buttonOnly: boolean = false;

    readonly ClipboardManager = inject(ClipboardManager);

    constructor(
    ) {
        super();
    }

    async Copy() {
        const text: string = this.textToCopy !== null ? this.textToCopy : this.content.nativeElement.textContent;
        await this.ClipboardManager.Copy(text, this.message);
    }
}
